module.exports = __webpack_public_path__ + "img/spinner.ecd31769.gif";